export default "__VITE_ASSET__h17pgRRZ__"